module.exports = __webpack_public_path__ + "static/media/setting@3x.2f63ae17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/setting@3x.png
// module id = 1962
// module chunks = 6